'use strict';

angular.module('teams').factory('ApiRequests', ['$resource',
	function($resource) {
		return $resource('v1/mau-api-requests', {
			mobileAppId: '@mobileAppId',
			languageId: '@languageId'
		}, {
			user: {
				method: 'GET',
				url : 'v1/mau-api-requests',
				isArray: false,
				cache : false
			},
			app: {
				method: 'GET',
				url : 'v1/projects/:mobileAppId/mau-api-requests',
				isArray: false,
				cache : false
			}
		});
	}
]);
